import React from "react"
import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"

import LoadingSplashScreen from "../components/loadingSplashScreen"

// Route only for authenticated users who are admins
const AdminRoute = ({ children }) => {
  const { isAuthenticated, isSupervisor, firstLoadStatus, isInstitutionAdmin } =
    useSelector((state) => state.user)

  // First time load splash screen
  if (firstLoadStatus === "loading") {
    return <LoadingSplashScreen />
  }

  if (isAuthenticated) {
    if (isSupervisor && isInstitutionAdmin) {
      return <>{children}</>
    } else if (isSupervisor) {
      return <Navigate to="/home" />
    } else {
      return <Navigate to="/trainee-home" />
    }
  }

  return <Navigate to="/login" />
}

export default AdminRoute
